import React from 'react';
import Drawing from "./Drawing";
import LiveResult from "./LiveResult";
import bgResult from "../../../../assets/images/live/live-result-day.png";

const ResultDay = (props) => {

    return (
        <>
            <div className="lay1">
                <Drawing {...props}/>
            </div>
            <div className="lay2" style={{
                backgroundImage: `url(${bgResult})`
            }}>
                <LiveResult {...props}/>
            </div>
        </>
    );
};

export default ResultDay;
